import { useShowComplianceCause } from '@givebacks/api/compliance';

/**
 * Controls if there should be access granted to the compliance account codes feature.
 */
const useHasAccessToComplianceAccountCodes = ({ causeId }: { causeId?: string }) => {
  const { data: hasComplianceAccess, isLoading } = useShowComplianceCause({
    uuid: causeId,
    select: (data) => Boolean(data?.account_code_on),
  });
  return { isEnabled: !!hasComplianceAccess, isLoading };
};

export { useHasAccessToComplianceAccountCodes };
